import React, { FC, useEffect } from "react";
import PageWrapper from "../../layout/PageWrapper/PageWrapper";
import * as InterialStyle from "../../styles/dabin/StyledComponenetInterialRenewal";

import InteriorRenewalHeroSection from "../../components/Enterprise/InteriorRenewalHeroSection";
import InteriorRenewalIntroduce from "../../components/Enterprise/InteriorRenewalIntroduce";
import InteriorRenewalBrand from "../../components/Enterprise/InteriorRenewalBrand";
import InteriorRenewalFunction from "../../components/Enterprise/InteriorRenewalFunction";
import KakaoIcon from "../../assets/icons/quick_kakao_icon.svg";
import { FiInstagram } from "react-icons/fi";
import { MdHomeFilled } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { getInteriorChannelInbound } from "../../Axios";


const InteriorRenewalPage: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const code = location.state?.code || 'interior';
  const referrer = location.state?.referrer;

  useEffect(() => {
    getInteriorChannelInbound(
      referrer,
    ).then(result => {
    });
  }, [referrer]);
  
  return (
    <>
      <PageWrapper title={'Welcome A.Black'}>
        <InterialStyle.InteriorRenewalPageContainer>
          <InteriorRenewalHeroSection/>
          <InteriorRenewalIntroduce/>
          <InteriorRenewalBrand/>
          <InteriorRenewalFunction/>
          <div className="buttons">
            <div className="bottom-buttons">
              <button 
                className="bottom-button_sign-up"
                onClick={()=> {
                  navigate('/join', {state: {code: code}});
                }}
              >
                A.Black 회원가입
              </button>
            </div>
            <div className="right-bottom-buttons">
              <button
                className="right-bottom-button"
                onClick={()=>window.open('https://shop.ambience.kr/', "_blank")}
              >
                <MdHomeFilled/>
              </button>
              <button
                className="right-bottom-button"
                onClick={()=>window.open('https://pf.kakao.com/_HMQQs', "_blank")}
              >
                <img src={KakaoIcon} alt="kakao_icon" />
              </button>
              <button
                className="right-bottom-button"
                onClick={()=>window.open('https://www.instagram.com/ambience_lighting/', "_blank")}
              >
                <FiInstagram/>
              </button>
            </div>
          </div>
        </InterialStyle.InteriorRenewalPageContainer>
      </PageWrapper>
    </>
  )
};

export default InteriorRenewalPage;